import { render, staticRenderFns } from "./LayoutProgramCommercialTaxes.vue?vue&type=template&id=767cfb28&scoped=true&"
import script from "./LayoutProgramCommercialTaxes.vue?vue&type=script&lang=js&"
export * from "./LayoutProgramCommercialTaxes.vue?vue&type=script&lang=js&"
import style0 from "./LayoutProgramCommercialTaxes.vue?vue&type=style&index=0&id=767cfb28&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "767cfb28",
  null
  
)

export default component.exports